module.exports = __webpack_public_path__ + "static/img/create1.1ad2a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/create1.png
// module id = 905
// module chunks = 1